import { useRegisterModuleNavigation } from '@/hooks/useRegisterModuleNavigation';

import { expensesNavigationItems } from '../navigation';

export function useExpensesModuleNavigation() {
  useRegisterModuleNavigation({
    moduleId: 'expenses',
    displayName: 'Despesas',
    items: expensesNavigationItems,
  });
}
